import { CancelPresentationOutlined, Close } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Slide,
  Stack,
  Toolbar,
  Typography,
  CircularProgress
} from "@mui/material";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { OrdiniRitiroContext,PreventiviNewContext} from "../../context";
import { useForm } from "../../hooks";
import PortoAssegnato from "./PortoAssegnato";
import PortoFranco from "./PortoFranco";
import Triangrolazione from "./Triangrolazione";
import { green } from '@mui/material/colors';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Configurazione ordine HARDCODED usata quando il ritiro viene creato da
// preventivo (formAuto popolato). In questo caso NON si chiama l'endpoint
// /ordini/config: il ritiro da preventivo è sempre in porto franco.
// Modificare qui le visibilità/sezioni desiderate.
const CONFIG_ORDER_FORM_AUTO = {
  ritiri: {
    mostrasottotitoli: true,
  },
  ritiri_franco: {
    titolo: "Porto franco",
    sottotitolo: "",
    orapronta: true,
    MittenteDefault: false,
    mittente: {
      visible: true,
      default_LuogoRitiro: false,
      riferimento_visible: true,
      readonly: false,
    },
    mittenteindicatori: { visible: false },
    destinatario: {
      visible: true,
      default_LuogoRitiro: false,
      riferimento_visible: true,
      readonly: false,
    },
    destinatarioindicatori: { visible: true },
    servizio: { visible: true },
    dettagliomisuremerce: { visible: true },
    totalemerce: { visible: false },
    notadimensioni: { visible: true },
    uploadfile: { visible: false },
    contrassegno: { visible: true },
    merceadr: { visible: true },
    assicurazione: { visible: true },
  },
};

const OrdiniMainForm = () => {
  const [confermaOrdiniMultipliOpen, setConfermaOrdiniMultipliOpen] = useState(false);
  const [salvataggioInCorso, setSalvataggioInCorso] = useState(false);

  const {
    state: { configOrder, formAuto,servizioAuto },
    postOrdine,
    getConfigModeOrder,
    getOrdiniCount,
    setConfigModeOrderAuto
  } = useContext(OrdiniRitiroContext);

    const {
      postCreaRitiroDaPreventivo
    } = useContext(PreventiviNewContext);

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      block: "end",
      behavior: "smooth",
    });
  };

  const navigate = useNavigate();
  const [title, setTitle] = React.useState("");
  const [open, setOpen] = React.useState(true);
  const [scegliModalita, setScegliModalita] = React.useState({
    portoFranco: false,
    portoAssegnato: false,
    triangolazione: false,
  });


  const handleClose = () => {
    if (formAuto && Object.keys(formAuto).length > 0) {
      // Se il form è stato aperto da un preventivo (formAuto popolato), chiudo e torno al dettaglio preventivo.
       navigate("/preventivi/preventivocalcolato");
    }
    else {

      navigate(-1);
    }
  };


  const onSave = () => {
    if (formAuto && Object.keys(formAuto).length > 0) {
      getOrdiniCount(addOrdiniForm, setConfermaOrdiniMultipliOpen, handleClose, navigate, postCreaRitiroDaPreventivo, setSalvataggioInCorso);
    }
    else {
      getOrdiniCount(addOrdiniForm, setConfermaOrdiniMultipliOpen, handleClose, navigate, postOrdine, setSalvataggioInCorso);
    }
  };

  const onConfermaOrdine = () => {
    if (formAuto && Object.keys(formAuto).length > 0) {
      postCreaRitiroDaPreventivo(formAuto, handleClose, navigate, setSalvataggioInCorso);
    }
    else {

      postOrdine(addOrdiniForm, handleClose, navigate,setSalvataggioInCorso);
    }

    setConfermaOrdiniMultipliOpen(false)    
  } 

  const onCloseDialogRitiriMultipli = () => {
    setSalvataggioInCorso(false);
    setConfermaOrdiniMultipliOpen(false);
  } 

  const goBack = () => {
    setOpen(!open);
    navigate("/ritiri");
  };

  useEffect(() => {
    // Ritiro creato da preventivo (formAuto popolato): config hardcoded,
    // niente chiamata a /ordini/config. Altrimenti carica la config dal server.
    if (formAuto && Object.keys(formAuto).length > 0) {
      setConfigModeOrderAuto(CONFIG_ORDER_FORM_AUTO);
    } else {
      getConfigModeOrder();
    }
  }, []);

  useEffect(() => {
    if (formAuto && Object.keys(formAuto).length > 0) {
      setOpen(false);
      setScegliModalita({
        portoFranco: true,
        portoAssegnato: false,
        triangolazione: false,
      });
      setTitle("Porto franco");
      setValues({
        ...addOrdiniForm,
        ResaPerWeb: "PF",
        Resa: "PF",
      });
    }
  }, [formAuto]);

  const {
    values: addOrdiniForm,
    changeHandler,
    setValues,
  } = useForm(
    {
      UploadFile: [],
      DataPronta: moment().format("YYYY-MM-DD"),
      OraPronta: "",
      MittNazione: "IT",
      MittLocalita: "",
      MittProvincia: "",
      MittCAP: "",
      MittRagSoc: "",
      MittCodiceIndirizzoCodificato: "",
      MittIndirizzo: "",
      MittPersona: "",
      MittTelefono: "",
      MittEmail: "",
      MittRiferimento: "",
      NotaRitiro: "",
      Orari: "",
      IndicatoriMitt: [],

      DestNazione: "IT",
      DestLocalita: "",
      DestProvincia: "",
      DestCAP: "",
      DestRagSoc: "",
      DestCodiceIndirizzoCodificato: "",
      DestIndirizzo: "",
      DestPersona: "",
      DestTelefono: "",
      DestEmail: "",
      DestRiferimento: "",
      NotaConsegna: "",
      IndicatoriDest: [],
      
      ServizioPerWeb: " ",
      ordmerce: [],
      StimaTipo: " ",
      StimaPeso: "",
      StimaVolume: "",
      StimaQuantita: "",
      StimaColli : "", 
      StimaPalette : "",
      NotaDimensioniMerce: "",
      ordadr: [],
      TipoIncassoCOD: " ",
      ImportoCOD: "",
      ValutaCOD: "EUR",
      
      StimaValMerce: "",
      StimaValMerceValuta: "EUR",
      ResaPerWeb: "",
      Resa: "",
      sceltaContrassegno: false,
      sceltaADR: false,
      sceltaAssicurazione: false,
    },
    []
    );
    
  const scrollOnBott = (liveData) => {
    if (liveData) {
      scrollToBottom();
    }
  };

  const mostrasottotitoli =()=>{
    if(configOrder?.ritiri?.mostrasottotitoli){
      return configOrder?.ritiri?.mostrasottotitoli;
    }
    else{
      return true;
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Card elevation={0}>
            <CardHeader
              title={"Modalità di ritiro"}
              action={
                <IconButton onClick={() => goBack()}>
                  <CancelPresentationOutlined color="error" />
                </IconButton>
              }
            />
            <Stack direction={"column"} justifyContent={"center"} spacing={3}>
              {configOrder?.ritiri_franco ? ( 
                <Card
                  elevation={1}
                  sx={{
                    border: 2,
                    borderColor: (theme) => theme.palette.secondary.main,
                  }}
                >
                  <CardHeader
                    title={configOrder?.ritiri_franco?.titolo}
                    subheader={ mostrasottotitoli() === false?  (""):(configOrder?.ritiri_triangolazione?.sottotitolo)}
                  />
                  <CardActions>
                    <Button
                      size={"small"}
                      variant="contained"
                      onClick={() => {
                        setOpen(!open);
                        setScegliModalita({
                          ...scegliModalita,
                          portoFranco: !scegliModalita.portoFranco,
                        });
                        setTitle("Porto franco");
                        setValues({
                          ...addOrdiniForm,
                          ResaPerWeb: "PF",
                          Resa: "PF",
                        });
                      }}
                    >
                      Seleziona
                    </Button>
                  </CardActions>
                </Card>
              ):(<></>)}
              {configOrder?.ritiri_assegnato ? (     
                <Card
                  elevation={1}
                  sx={{
                    border: 2,
                    borderColor: (theme) => theme.palette.secondary.main,
                  }}
                >
                  <CardHeader
                    title={configOrder?.ritiri_assegnato?.titolo}
                    subheader={mostrasottotitoli() === false?  (""):(configOrder?.ritiri_triangolazione?.sottotitolo)}
                  />
                  <CardActions>
                    <Button
                      size={"small"}
                      variant="contained"
                      onClick={() => {
                        setOpen(!open);
                        setScegliModalita({
                          ...scegliModalita,
                          portoAssegnato: !scegliModalita.portoAssegnato,
                        });
                        setTitle("Porto assegnato");
                        setValues({
                          ...addOrdiniForm,
                          ResaPerWeb: "PA",
                          Resa: "PA",
                        });
                      }}
                    >
                      Seleziona
                    </Button>
                  </CardActions>
                </Card>
              ):(<></>)}
              {configOrder?.ritiri_triangolazione ? ( 
                <Card
                  elevation={1}
                  sx={{
                    border: 2,
                    borderColor: (theme) => theme.palette.secondary.main,
                  }}
                >
                  <CardHeader
                    title={configOrder?.ritiri_triangolazione?.titolo}
                    subheader={mostrasottotitoli() === false? (""):(configOrder?.ritiri_triangolazione?.sottotitolo)}
                  />
                  <CardActions>
                    <Button
                      variant="contained"
                      size={"small"}
                      onClick={() => {
                        setOpen(!open);
                        setScegliModalita({
                          ...scegliModalita,
                          triangolazione: !scegliModalita.triangolazione,
                        });
                        setTitle("Porto triangolazione");
                        setValues({
                          ...addOrdiniForm,
                          ResaPerWeb: "TR",
                          Resa: "TR",
                        });
                      }}
                    >
                      Seleziona
                    </Button>
                  </CardActions>
                </Card>
              ):(<></>)}

            </Stack>
          </Card>
        </DialogContent>
      </Dialog>
      <AppBar sx={{ position: "fixed" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <Close />
          </IconButton>

          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>

          <Stack direction={"row"} spacing={2}>
            <Button
              color="warning"
              size={"small"}
              variant={"contained"}
              onClick={handleClose}
              disabled={salvataggioInCorso}

            >
              annulla
            </Button>
            <Box sx={{position:'relative'}}>
              <Button
                color="success"
                size={"medium"}
                variant={"contained"}
                onClick={() => onSave()}
                disabled={salvataggioInCorso}

              >
                salva
              </Button>
              {              
                salvataggioInCorso && (
                  <CircularProgress
                    size={20}
                    sx={{
                      color: green[500],
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}  
            </Box>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box pt={9} pb={1}>
        {scegliModalita.portoFranco ? (
          <PortoFranco
            configOrder={configOrder}
            setMainForm={setValues}
            mainForm={addOrdiniForm}
            scrollOnBott={scrollOnBott}
            formAutomatico={formAuto}
            servizioAutomatico={servizioAuto}
          />
        ) : (
          <></>
        )}
        {scegliModalita.portoAssegnato ? (
          <PortoAssegnato
            configOrder={configOrder}
            setMainForm={setValues}
            mainForm={addOrdiniForm}
            scrollOnBott={scrollOnBott}
            formAutomatico={formAuto}
            servizioAutomatico={servizioAuto}
          />
        ) : (
          <></>
        )}
        {scegliModalita.triangolazione ? (
          <Triangrolazione
            configOrder={configOrder}
            setMainForm={setValues}
            mainForm={addOrdiniForm}
            scrollOnBott={scrollOnBott}
            formAutomatico={formAuto}
            servizioAutomatico={servizioAuto}
          />
        ) : (
          <></>
        )}
        {!scegliModalita.portoAssegnato &&
        !scegliModalita.triangolazione &&
        !scegliModalita.portoFranco ? (
          <></>
        ) : (
          <Stack direction={"row-reverse"} spacing={2} mt={2}>
            <Box sx={{position:'relative'}}>
              <Button
                color="success"
                size={"medium"}
                variant={"contained"}
                onClick={() => onSave()}
                disabled={salvataggioInCorso}

              >
                salva
              </Button>
              {              
                salvataggioInCorso && (
                  <CircularProgress
                    size={20}
                    sx={{
                      color: green[500],
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}  
            </Box>
            <Button
              color="warning"
              size={"medium"}
              variant={"contained"}
              onClick={handleClose}
              disabled={salvataggioInCorso}

            >
              annulla
            </Button>
          </Stack>
        )}
      </Box>

      <Dialog
        open={confermaOrdiniMultipliOpen}
        onClose={() => setConfermaOrdiniMultipliOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Conferma inserimento di ritiri multipli.
        </DialogTitle >  
        <DialogContent>
          <DialogContentText>
            Sono già presenti ritiri con stessa resa e mittente per il giorno {addOrdiniForm.DataPronta}.
            Confermi l'inserimento?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => onCloseDialogRitiriMultipli()}>
            Annulla
          </Button>
          <Button onClick={() => onConfermaOrdine()}>
            Conferma
          </Button>
        </DialogActions>
        
      </Dialog>
    </div>
  );
};

export default OrdiniMainForm;
